import { connect } from "react-redux";
import * as terminatedLoanActions from "./terminatedLoansActions";
import * as fileActions from "./terminationFileActions";

function mapStateToProps(state) {
  return {
    terminatedLoans: state.terminatedCollectionLoans,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTerminatedLoans: () => {
      dispatch(terminatedLoanActions.get_terminated_loans());
    },

    loadFiles: () => {
      dispatch(fileActions.load_files());
    },

    createFiles: () => {
      dispatch(fileActions.create_files());
    },

    loadDetails: (id) => {
      dispatch(fileActions.load_file_details(id));
    },

    finalizeFile: (id) => {
      dispatch(fileActions.finalize_file(id));
    },

    removeLoanFromFile: (fileId, loanId) => {
      dispatch(fileActions.remove_loan_form_file(fileId, loanId));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps);
